import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';

import { FeedbackHistoryComponent } from './feedback-history/feedback-history.component';

@NgModule({
    imports: [CommonModule, TranslateModule, IonicModule],
    exports: [FeedbackHistoryComponent],
    declarations: [FeedbackHistoryComponent]
})
export class FeedbackModule {}
